import React, { useState } from "react";
import { Formik, Form, Field, FieldArray, FastField } from "formik";
import { useNavigate } from 'react-router-dom';

export default function Singleitem() {
  const navigate = useNavigate();

  const [ShowUserDropDown, setShowUserDropDown] = useState(false);
  const [ShowTypeDropDown, setShowTypeDropDown] = useState(false);
  const [ShowstatusDropDown, setShowstatusDropDown] = useState(false);
  const [ShowsupplierDropDown, setShowsupplierDropDown] = useState(false);
  const [ShowcompanyDropDown, setShowcompanyDropDown] = useState(false);

  const [Users, setUsers] = useState([
    {
      full_name: "",
    },
  ]);
  const initialValues = {
    name: "",
    users: "",
    street_name: "",
    door_number: "",
    country: "",
    city: "",
    phone_number: "",
    website: "",
    contacts: [],
  };
  const onSubmit = (values, onSubmitProps) => {};
  const RemoveTemplateHandler = (remove, index) => {
    remove(index);
  };
  const AddTemplateHandler = (push) => {
    push({
      name: "",
      job_role: "",
      phone_number: "",
      email: "",
    });
  };
  return (
    <div>
      <div>
        <h2 className="font-Montserrat text-xl font-bold text-black">
          Scan/Print barcodes
        </h2>
        <div className="border-b-2 border-blue-200 w-20"></div>
      </div>
      <div className="flex flex-col justify-items-center ml-8 mt-12 bg-white pl-8 py-8">
        <div className="flex mb-8">
          <h2 className="font-Montserrat text-lg font-medium text-black mr-2">
            Print Barcode for Item
          </h2>
          <svg
            className="mt-1"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_997_7304)">
              <path
                d="M17.3693 18.6125L17.012 18.8156V17.0271L17.3693 16.824V18.6125ZM20.3099 15.149L19.9536 15.3521V17.1406L20.3099 16.9375V15.149ZM23.9557 7.23021V19.2167L13.7995 25L1.03906 17.7312V5.74479L11.213 0L23.9557 7.23021ZM9.53281 3.34167L18.9307 8.73542L20.7016 7.78021L11.2089 2.39479L9.53281 3.34167ZM12.4974 13.425L3.1224 7.98958V16.5208L12.4974 21.8604V13.425ZM15.6443 10.499L6.45781 5.06458L4.32865 6.28021L13.5578 11.6323L15.6443 10.499ZM21.8724 9.51667L19.7891 10.6396V13.5417L16.6641 15.3V12.325L14.5807 13.4479V22.1583L21.8724 18.0073V9.51667ZM16.7609 17.1708L16.3974 17.3781V19.1625L16.7609 18.9594V17.1708ZM18.2245 16.3375L17.8661 16.5417V18.3302L18.2245 18.126V16.3375ZM18.8224 15.9969L18.4651 16.2V17.9885L18.8224 17.7854V15.9969ZM19.4307 15.65L19.0661 15.8573V17.6458L19.4307 17.4385V15.65Z"
                fill="#AD8762"
              />
            </g>
            <defs>
              <clipPath id="clip0_997_7304">
                <rect width="25" height="25" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          //   validationSchema={validationSchema}
          //   validateOnMount
        >
          <Form>
            <div className="grid space-y-8">
              <Field name="item">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      <button
                        id="dropdownButton"
                        className=" font-Montserrat border-1 border-solid border-gray
              focus:border-blue-100 focus:outline-none text-gray-50 font-medium mr-3  bg-transparent relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-center inline-flex items-center"
                        type="button"
                        onClick={() => setShowUserDropDown(!ShowUserDropDown)}
                      >
                        Select Item/Assembly
                        <svg
                          className="w-4 h-4 ml-auto"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                          ></path>
                        </svg>
                      </button>
                      {ShowUserDropDown ? (
                        <div>
                          <div
                            id="dropdown"
                            className="z-10 -mt-6 absolute bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700"
                          >
                            <ul
                              className="py-1 text-sm text-gray-700 font-medium font-Montserrat"
                              aria-labelledby="dropdownRightButton"
                              {...field}
                            >
                              {Users.map((users, index) => (
                                <li key={index}>
                                  <a className="block px-4 py-2 hover:bg-cyan-200">
                                    {users.full_name === ""
                                      ? null
                                      : users.full_name}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ) : null}
                    </>
                  );
                }}
              </Field>
              <Field name="version">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      <button
                        id="dropdownButton"
                        className=" font-Montserrat border-solid border-gray
              focus:border-blue-100 focus:outline-none text-gray-50 font-medium mr-3 border-1 bg-transparent relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-center inline-flex items-center"
                        type="button"
                        onClick={() => setShowTypeDropDown(!ShowTypeDropDown)}
                      >
                        Select Version
                        <svg
                          className="w-4 h-4 ml-auto"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                          ></path>
                        </svg>
                      </button>
                      {ShowTypeDropDown ? (
                        <div>
                          <div
                            id="dropdown"
                            className="z-10 -mt-6 absolute bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700"
                          >
                            <ul
                              className="py-1 text-sm text-gray-700 font-medium font-Montserrat"
                              aria-labelledby="dropdownRightButton"
                              {...field}
                            >
                              <li>
                                <a className="block px-4 py-2 hover:bg-cyan-200">
                                  Type A
                                </a>
                                <a className="block px-4 py-2 hover:bg-cyan-200">
                                  Type B
                                </a>
                                <a className="block px-4 py-2 hover:bg-cyan-200">
                                  Type C
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      ) : null}
                    </>
                  );
                }}
              </Field>
              <Field name="purchasedate">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      {/* <svg
            width="15"
            height="20"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5 12.5H10V10H12.5V12.5ZM8.75 6.25H6.25V8.75H8.75V6.25ZM12.5 6.25H10V8.75H12.5V6.25ZM5 10H2.5V12.5H5V10ZM8.75 10H6.25V12.5H8.75V10ZM5 6.25H2.5V8.75H5V6.25ZM15 1.25V15H0V1.25H1.875V1.875C1.875 2.56437 2.43563 3.125 3.125 3.125C3.81437 3.125 4.375 2.56437 4.375 1.875V1.25H10.625V1.875C10.625 2.56437 11.1856 3.125 11.875 3.125C12.5644 3.125 13.125 2.56437 13.125 1.875V1.25H15ZM13.75 5H1.25V13.75H13.75V5ZM12.5 0.625C12.5 0.28 12.2206 0 11.875 0C11.5294 0 11.25 0.28 11.25 0.625V1.875C11.25 2.22 11.5294 2.5 11.875 2.5C12.2206 2.5 12.5 2.22 12.5 1.875V0.625ZM3.75 1.875C3.75 2.22 3.47062 2.5 3.125 2.5C2.77938 2.5 2.5 2.22 2.5 1.875V0.625C2.5 0.28 2.77938 0 3.125 0C3.47062 0 3.75 0.28 3.75 0.625V1.875Z"
              fill="black"
              fill-opacity="0.7"
            />
          </svg> */}

                      <input
                        {...field}
                        type="date"
                        {...(meta.touched && meta.error
                          ? {
                              className:
                                "border-1 bg-transparent rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                            }
                          : {
                              className:
                                "border-1 bg-transparent rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                            })}
                        placeholder="Purchase Date"
                      ></input>
                      {meta.touched && meta.error ? (
                        <label className="text-xs font-Montserrat text-red-500">
                          <span className="ml-1">{meta.error}</span>
                        </label>
                      ) : null}
                    </>
                  );
                }}
              </Field>
              <Field name="arrivaldate">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      {/* <svg
          width="15"
          height="20"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5 12.5H10V10H12.5V12.5ZM8.75 6.25H6.25V8.75H8.75V6.25ZM12.5 6.25H10V8.75H12.5V6.25ZM5 10H2.5V12.5H5V10ZM8.75 10H6.25V12.5H8.75V10ZM5 6.25H2.5V8.75H5V6.25ZM15 1.25V15H0V1.25H1.875V1.875C1.875 2.56437 2.43563 3.125 3.125 3.125C3.81437 3.125 4.375 2.56437 4.375 1.875V1.25H10.625V1.875C10.625 2.56437 11.1856 3.125 11.875 3.125C12.5644 3.125 13.125 2.56437 13.125 1.875V1.25H15ZM13.75 5H1.25V13.75H13.75V5ZM12.5 0.625C12.5 0.28 12.2206 0 11.875 0C11.5294 0 11.25 0.28 11.25 0.625V1.875C11.25 2.22 11.5294 2.5 11.875 2.5C12.2206 2.5 12.5 2.22 12.5 1.875V0.625ZM3.75 1.875C3.75 2.22 3.47062 2.5 3.125 2.5C2.77938 2.5 2.5 2.22 2.5 1.875V0.625C2.5 0.28 2.77938 0 3.125 0C3.47062 0 3.75 0.28 3.75 0.625V1.875Z"
            fill="black"
            fill-opacity="0.7"
          />
        </svg> */}

                      <input
                        {...field}
                        type="date"
                        {...(meta.touched && meta.error
                          ? {
                              className:
                                "border-1 bg-transparent rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                            }
                          : {
                              className:
                                "border-1 bg-transparent rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                            })}
                        placeholder="Arrival Date"
                      ></input>
                      {meta.touched && meta.error ? (
                        <label className="text-xs font-Montserrat text-red-500">
                          <span className="ml-1">{meta.error}</span>
                        </label>
                      ) : null}
                    </>
                  );
                }}
              </Field>
              <Field name="supplier">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      <button
                        id="dropdownButton"
                        className=" font-Montserrat border-solid border-gray
        focus:border-blue-100 focus:outline-none text-gray-50 font-medium mr-3 border-1 bg-transparent relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-center inline-flex items-center"
                        type="button"
                        onClick={() =>
                          setShowsupplierDropDown(!ShowsupplierDropDown)
                        }
                      >
                        Select Supplier
                        <svg
                          className="w-4 h-4 ml-auto"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                          ></path>
                        </svg>
                      </button>
                      {ShowsupplierDropDown ? (
                        <div>
                          <div
                            id="dropdown"
                            className="z-10 -mt-6 absolute bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700"
                          >
                            <ul
                              className="py-1 text-sm text-gray-700 font-medium font-Montserrat"
                              aria-labelledby="dropdownRightButton"
                              {...field}
                            >
                              <li>
                                <a className="block px-4 py-2 hover:bg-cyan-200">
                                  Type A
                                </a>
                                <a className="block px-4 py-2 hover:bg-cyan-200">
                                  Type B
                                </a>
                                <a className="block px-4 py-2 hover:bg-cyan-200">
                                  Type C
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      ) : null}
                    </>
                  );
                }}
              </Field>
              <Field name="tracking">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      {/* <svg
              width="15"
              height="20"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5 12.5H10V10H12.5V12.5ZM8.75 6.25H6.25V8.75H8.75V6.25ZM12.5 6.25H10V8.75H12.5V6.25ZM5 10H2.5V12.5H5V10ZM8.75 10H6.25V12.5H8.75V10ZM5 6.25H2.5V8.75H5V6.25ZM15 1.25V15H0V1.25H1.875V1.875C1.875 2.56437 2.43563 3.125 3.125 3.125C3.81437 3.125 4.375 2.56437 4.375 1.875V1.25H10.625V1.875C10.625 2.56437 11.1856 3.125 11.875 3.125C12.5644 3.125 13.125 2.56437 13.125 1.875V1.25H15ZM13.75 5H1.25V13.75H13.75V5ZM12.5 0.625C12.5 0.28 12.2206 0 11.875 0C11.5294 0 11.25 0.28 11.25 0.625V1.875C11.25 2.22 11.5294 2.5 11.875 2.5C12.2206 2.5 12.5 2.22 12.5 1.875V0.625ZM3.75 1.875C3.75 2.22 3.47062 2.5 3.125 2.5C2.77938 2.5 2.5 2.22 2.5 1.875V0.625C2.5 0.28 2.77938 0 3.125 0C3.47062 0 3.75 0.28 3.75 0.625V1.875Z"
                fill="black"
                fill-opacity="0.7"
              />
            </svg> */}

                      <input
                        {...field}
                        type="number"
                        {...(meta.touched && meta.error
                          ? {
                              className:
                                "border-b-2 bg-transparent font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                            }
                          : {
                              className:
                                "border-b-2 bg-transparent font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                            })}
                        placeholder="Tracking Id"
                      ></input>
                      {meta.touched && meta.error ? (
                        <label className="text-xs font-Montserrat text-red-500">
                          <span className="ml-1">{meta.error}</span>
                        </label>
                      ) : null}
                    </>
                  );
                }}
              </Field>
              <Field name="company">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      <button
                        id="dropdownButton"
                        className=" font-Montserrat border-solid border-gray
      focus:border-blue-100 focus:outline-none text-gray-50 font-medium mr-3 border-1 bg-transparent relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-center inline-flex items-center"
                        type="button"
                        onClick={() =>
                          setShowcompanyDropDown(!ShowcompanyDropDown)
                        }
                      >
                        Delivery Company
                        <svg
                          className="w-4 h-4 ml-auto"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                          ></path>
                        </svg>
                      </button>
                      {ShowcompanyDropDown ? (
                        <div>
                          <div
                            id="dropdown"
                            className="z-10 -mt-6 absolute bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700"
                          >
                            <ul
                              className="py-1 text-sm text-gray-700 font-medium font-Montserrat"
                              aria-labelledby="dropdownRightButton"
                              {...field}
                            >
                              <li>
                                <a className="block px-4 py-2 hover:bg-cyan-200">
                                  Type A
                                </a>
                                <a className="block px-4 py-2 hover:bg-cyan-200">
                                  Type B
                                </a>
                                <a className="block px-4 py-2 hover:bg-cyan-200">
                                  Type C
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      ) : null}
                    </>
                  );
                }}
              </Field>
              <Field name="status">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      <button
                        id="dropdownButton"
                        className=" font-Montserrat border-solid border-gray
    focus:border-blue-100 focus:outline-none text-gray-50 font-medium mr-3 border-1 bg-transparent relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-center inline-flex items-center"
                        type="button"
                        onClick={() =>
                          setShowstatusDropDown(!ShowstatusDropDown)
                        }
                      >
                        Select Status
                        <svg
                          className="w-4 h-4 ml-auto"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                          ></path>
                        </svg>
                      </button>
                      {ShowstatusDropDown ? (
                        <div>
                          <div
                            id="dropdown"
                            className="z-10 -mt-6 absolute bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700"
                          >
                            <ul
                              className="py-1 text-sm text-gray-700 font-medium font-Montserrat"
                              aria-labelledby="dropdownRightButton"
                              {...field}
                            >
                              <li>
                                <a className="block px-4 py-2 hover:bg-cyan-200">
                                  Type A
                                </a>
                                <a className="block px-4 py-2 hover:bg-cyan-200">
                                  Type B
                                </a>
                                <a className="block px-4 py-2 hover:bg-cyan-200">
                                  Type C
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      ) : null}
                    </>
                  );
                }}
              </Field>
            </div>
          </Form>
        </Formik>

        <div className="mt-8">
          <div className="flex flex-col justify-items-center">
            <Formik
            //   initialValues={GroupInitialValues}
            //   onSubmit={GroupOnSubmit}
              //   validationSchema={validationSchema}
              //   validateOnMount
            >
              <Form>
                <div className="flex flex-row justify-center space-x-128 my-10">
                  <button
                    type="button"
                    className="text-red-600 font-Montserrat font-medium text-lg"
                    onClick={() => navigate("/dashboard/warehouse/printscan")}

                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="font-Montserrat font-semibold text-white mr-5 flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow"
                    style={{marginRight:"20px"}}
                    onClick={() => navigate("/dashboard/warehouse/printscan/barcode-details")}
                  >
                    Print Barcode
                  </button>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}
